<template>
  <div class="box1">
    <div id="block"></div>
    <img class="banner-icon" src="../../../assets/coursePage/ai/banner-icon.png" alt="">
    <div class="text-box">
      <div class="title">
        人工智能
        <p>顺势而为，AI创新未来</p>
      </div>

      <div class="gradual-change-box">
        <div class="gradual-change">编写程序</div>
        <br />
        <div class="gradual-change">像人一样思考、判断、推理</div>
        <br />
        <div class="gradual-change">应用服务各行各业</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;
 
  width: 100%;
  height: 680px;
  background: url("../../../assets/coursePage/ai/banner.png") no-repeat;
  background-size: cover;
  background-position: center;

  #block {
    width: 100%;
    height: 88px;
  }

  .banner-icon {
    position: absolute;
    right: 24px;
    bottom: 80px;
    width: 348px;
    height: 260px;
  }

  .text-box {
    padding-left: 60px;
    padding-top: 80px;
    width: 100%;
    box-sizing: border-box;
    .title {
      margin-bottom: 44px;
      font-size: 68px;
      font-family: PingFangHK-Semibold;
      font-weight: 600;
      color: #273f6e;
      line-height: 96px;
      letter-spacing: 22px;
      -webkit-text-stroke: 1px #273f6e;
      text-stroke: 1px #273f6e;
      p {
        margin-top: 8px;
        font-size: 32px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #273f6e;
        line-height: 44px;
        letter-spacing: 1px;
      }
    }
  }

  .gradual-change-box {
    div {
      position: relative;
      display: inline-block;
      margin-bottom: 32px;
      padding: 0 16px;
      width: flex;
      height: 56px;
      background: linear-gradient(270deg, #1fd7cd 0%, #65adff 100%);
      line-height: 58px;
      border-radius: 48px;
      border: 4px solid #ffffff;
      font-size: 24px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #ffffff;

      &::after {
        position: absolute;
        left: 56px;
        bottom:-28px;
        content: '';
        width: 16px;
        height: 16px;
        background: url('../../../assets/coursePage/ai/arrow.png') no-repeat;
        background-size: cover;
      }
      &:last-child {
        &::after{
          display: none;
          content: '';
        }
      }
    }
  }
}
</style>